(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5263],{

/***/ 40350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ PremiumAuthGuard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./app/context/auth.context.tsx
var auth_context = __webpack_require__(92862);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(1653);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(43337);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./services-hooks/services.ts + 1 modules
var services = __webpack_require__(46725);
// EXTERNAL MODULE: ./app/components/back-button/back-button.component.tsx
var back_button_component = __webpack_require__(56227);
// EXTERNAL MODULE: ./app/components/icons/AddToPlaylist.tsx
var AddToPlaylist = __webpack_require__(2035);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/icons/HighQualityOutlined.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var HighQualityOutlined = function HighQualityOutlined(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 58 36",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 8.02v19.248c0 4.42 3.562 8.02 7.937 8.02h41.271c4.375 0 7.937-3.6 7.937-8.02V8.02c0-4.42-3.562-8.02-7.937-8.02H7.937C3.559 0 0 3.6 0 8.02zm49.205-4.813c2.626 0 4.764 2.16 4.764 4.813v19.248c0 2.654-2.138 4.813-4.764 4.813H7.937c-2.626 0-4.763-2.16-4.763-4.813V8.02c0-2.653 2.137-4.813 4.763-4.813h41.268z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.913 24.831c.735 0 1.281-.567 1.281-1.302v-4.6h6.847v4.6c0 .735.672 1.302 1.428 1.302.735 0 1.303-.567 1.303-1.302v-11.93c0-.756-.567-1.302-1.303-1.302-.756 0-1.428.546-1.428 1.302v4.579h-6.847v-4.579c0-.756-.546-1.302-1.28-1.302-.946 0-1.492.546-1.492 1.302v11.93c0 .735.546 1.302 1.491 1.302z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M43.74 17.669c0-5.167-3.822-7.792-7.729-7.792-3.717 0-7.918 2.625-7.918 7.792s4.222 7.708 7.918 7.708c1.702 0 2.983-.357 4.075-1.113l.714.567c1.407 1.323 3.214-.735 1.827-1.995l-.336-.4c.945-1.302 1.45-2.772 1.45-4.767zm-5.838.357l2.373 2.373c.525-.735.756-1.638.756-2.73 0-3.34-2.625-5.04-5.02-5.04-2.583 0-5.124 1.7-5.124 5.04 0 2.541 2.163 4.957 5.124 4.957.756 0 1.492-.19 2.227-.378l-2.395-2.206c-1.113-1.344.651-3.255 2.059-2.016z",
      fill: "#000"
    })]
  }));
};

var MemoHighQualityOutlined = /*#__PURE__*/(0,react.memo)(HighQualityOutlined);
/* harmony default export */ var icons_HighQualityOutlined = (MemoHighQualityOutlined);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
;// CONCATENATED MODULE: ./app/components/icons/NoAds.tsx


function NoAds_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NoAds_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NoAds_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NoAds_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var NoAds = function NoAds(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", NoAds_objectSpread(NoAds_objectSpread({
    fill: "none",
    width: "1em",
    height: "1em",
    viewBox: "0 0 63 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 9.855v21.956c0 5.042 3.881 9.148 8.648 9.148h44.97c4.766 0 8.648-4.106 8.648-9.149V9.856c0-5.043-3.882-9.148-8.648-9.148H8.648C3.878.707 0 4.812 0 9.855Zm53.614-5.49c2.862 0 5.19 2.463 5.19 5.49v21.956c0 3.026-2.328 5.49-5.19 5.49H8.648c-2.861 0-5.19-2.464-5.19-5.49V9.855c0-3.027 2.329-5.49 5.19-5.49h44.966Z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.844 23.228c-.219-2.3-2.522-2.922-4.52-3.462-1.703-.46-3.185-.86-2.96-2.192.392-1.899 3.533-1.497 4.916-.639 1.122.804 2.468-.785 1.197-1.79-2.58-1.935-8.058-1.296-8.488 2.247-.228 2.04.838 3.026 2.229 3.636l7.626 2.2Zm-11.91-3.436c-.457-2.72-2.524-5.14-6.261-5.14h-4.281c-.617 0-1.29.476-1.29 1.133v.593l2.468.712v-.21h3.103c1.748 0 2.892.9 3.456 2.103l2.805.809Zm-2.409 1.529 2.428.7c-.415 2.773-2.474 5.268-6.112 5.268h-4.45c-.616 0-1.289-.33-1.289-1.133v-7.554l2.468.712v5.747h3.103c2.38 0 3.687-1.818 3.852-3.74ZM16.52 15.837l3.388.978 4.488 8.72c.766 1.425-1.496 2.557-2.169 1.133l-.822-1.607h-6.899l-.803 1.607c-.3.62-.991.748-1.664.62-.598-.328-.972-.985-.598-1.752l5.08-9.699Zm30.526 8.808 2.42.698c-1.512 2.994-6.964 2.834-9.196 1.033-.617-.493-.598-1.297-.262-1.79.486-.475 1.028-.639 1.664-.128 1.29.861 4.29 1.541 5.374.187Zm-31.38-1.994 2.299-4.51 2.112 4.51h-4.412Z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m17.122 13.787 33.581 9.835",
      stroke: "#000",
      strokeWidth: 1.069,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.396 13.152 54.4 25.174",
      stroke: "#000",
      strokeWidth: 3.206
    })]
  }));
};

var MemoNoAds = /*#__PURE__*/(0,react.memo)(NoAds);
/* harmony default export */ var icons_NoAds = (MemoNoAds);
;// CONCATENATED MODULE: ./app/components/icons/WindbackBig.tsx


function WindbackBig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WindbackBig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WindbackBig_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WindbackBig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var WindbackBig = function WindbackBig(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", WindbackBig_objectSpread(WindbackBig_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M24 12.084V.417L9.417 15 24 29.584V17.917c9.654 0 17.5 7.846 17.5 17.5s-7.846 17.5-17.5 17.5-17.5-7.846-17.5-17.5H.667C.667 48.309 11.109 58.75 24 58.75c12.892 0 23.334-10.441 23.334-23.333 0-12.892-10.442-23.333-23.334-23.333Z",
      fill: "#000"
    })
  }));
};

var MemoWindbackBig = /*#__PURE__*/(0,react.memo)(WindbackBig);
/* harmony default export */ var icons_WindbackBig = (MemoWindbackBig);
;// CONCATENATED MODULE: ./app/components/icons/WorldsBest.tsx


function WorldsBest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WorldsBest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WorldsBest_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WorldsBest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var WorldsBest = function WorldsBest(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", WorldsBest_objectSpread(WorldsBest_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 51 74",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M25.228 25.96c-12.027 0-21.811 9.784-21.811 21.81 0 12.027 9.784 21.811 21.81 21.811 12.027 0 21.811-9.784 21.811-21.81 0-12.027-9.784-21.811-21.81-21.811zm0 42.5c-11.029 0-20.067-8.67-20.659-19.552l1.264.649 1.18.32 1.857 1.037.429.536.856.428.5.322v.536l-.357.75.357.678v1.072l.464.394s.643.75.75.856c.109.108.93.75.93.75s.5.394.607.5c.107.107.535.786.57.93.037.142.357 1.285.394 1.392.036.107.215.5.393.928.18.429.357.964.357 1.072 0 .107.393 1.107.393 1.107s.322.75.429.964c.107.214.428.75.57.964.144.215.465.714.787.893.32.179.75.5.75.5s.464.18.357 0c-.108-.179-.357-.571-.466-.821-.107-.25-.142-.643-.178-.75-.036-.108-.357-.786-.357-.894 0-.107.037-.25.037-.428 0-.179.107-.536.178-.893.072-.357.107-1.07.25-1.179.143-.107.322-.464.322-.571 0-.107.283-.536.23-.679-.052-.142-.185-1.107.007-1.214.192-.107.834-.571.942-.678.108-.108.285-.893.285-1 0-.108.25-1.357.286-1.536.036-.179 0-.75 0-.964 0-.214-.321-.465-.57-.679-.25-.214-.68-.393-.859-.393-.178 0-1.357-.428-1.429-.536-.07-.107-.321-.357-.428-.57-.107-.215-.75-.787-1.036-.822-.285-.036-1-.286-1.107-.501-.107-.214-.143-.464-.25-.464-.107 0-.857.036-.964.036-.107 0-.358-.036-.643-.18-.286-.142-.607-.32-.964-.142-.358.18-.536.394-.643.428-.107.037-.556.037-.599.037-.044 0-1.15-.108-1.15-.108v-.714-.643s-.823-.035-.93-.035c-.106 0-.179-.357-.179-.571 0-.215.465-.465.214-.608-.25-.142-.25-.357-.428-.214-.18.142-.286.285-.536.5-.25.214-.643.285-.928.036-.286-.25-.5-1.036-.536-1.179-.035-.143-.071-.571.07-.785.144-.215.395-.429.68-.571.286-.143.857-.18.964-.215.107-.035.893-.428.893-.428l.715.464s.285.714.428.857c.143.143.322.286.357.179.036-.108-.107-.893-.107-1 0-.106-.037-.892.072-.964.107-.072.607-.393.713-.465.108-.071.25-.25.287-.428.035-.179.249-.643.356-.68.108-.035 0-.535.465-.785.464-.25.607-.25.679-.428.07-.178.5-.571.5-.571s.357.142.57 0c.216-.143.714-.25.966-.358.249-.107.427 0 .213-.357-.213-.356-.286-.535-.465-.642-.178-.108-.178-.394-.178-.394s.786.143.928 0c.143-.142.965-.642.894-.464-.072.179-.572.965-.572.965l.536.321s.571.57.68.214c.106-.356.25-.607.07-.856-.179-.25-.25-.928-.25-1.036 0-.108-.25-.857-.25-.857s-.572-.608-.501-.822c.072-.214.144-.536.144-.642v-.571l-.965.642-.071-.25s.107-.214.107-.393c0-.18-.107-.5-.286-.608-.178-.107-.678-.429-.678-.429l-.572.572-.32.643s.035.357.035.465c0 .107-.251.642-.358.75-.107.107-.643.75-.678.856-.036.108-.393.5-.393.5s.036-.321 0-.642-.286-.642-.536-.858c-.25-.213-.67-.963-.67-.963s.063-.572.456-1c.392-.429.928-.893 1.107-1.036.178-.143.821-.714.821-.714s.393-.322.286 0c-.108.321-.25.928-.25.928s.5-.071.607-.071c.108 0 .286-.322.143-.465-.143-.143-.357 0-.143-.143.215-.142.607-.428.715-.536.107-.107.641-1.107.714-1.25.07-.143.284-.428.393-.25.107.179.428.5.392.75-.035.25-.5 1.036-.5 1.036s-.463.143-.535.286c-.071.143.072.75.072.75s.392.214.607.392c.214.18.571.215.75-.035.178-.25.786-.643.857-.75.071-.108.25-.857.25-.857l-.143-.464.108-.715s.036-.893-.143-.678c-.18.214-.322-.858-.322-.965 0-.107.285-.464-.07-.571-.359-.107-.68-.179-.823-.215-.093-.023-.346-.137-.656-.235a20.567 20.567 0 013.853-1.672c-.276.65-.769 1.407-.769 1.407s-.249.358-.142.5c.108.143.053.358-.027.429-.08.072-.295.357-.295.357s-.07.322.143.5c.215.179-.214.607.68.179.892-.429.82-.465 1.07-.714.25-.25.714-.68.893-.822.18-.143.786-.515.786-.515s.178-.092 0 .193c-.18.286-.393.5-.643.715-.25.214-.25.214-.393.428-.143.215-.286.726-.321.9-.037.172.035.421.142.421.108 0 .215-.214.358 0 .141.215.106 0 .141.215.037.214.073-.036.037.642-.037.68-.143 2.144-.143 2.144s-.214.321-.285.499c-.072.18-.18.215-.286.429-.107.214-.072-.107-.107.214-.037.322-.109.643-.109.643v.893c0 .143.286 1.107.394 1.213.108.108.358.18.393 0 .036-.178.516-.963.516-.963s.214-.214.386-.394c.17-.178 1.776-1.142 2.063-1.25.285-.107.536-.25.679-.321.142-.071.356-.071.535-.357.18-.286.5-1.179.5-1.179s-.357-.536-.214-.714c.143-.178-.037-.143.214-.357.25-.215.357-.285.536-.714.178-.429.392-1.107.392-1.43 0-.32-.071-.356.144-.606.214-.251.25-.215.393-.43.143-.213.214-.463.214-.463s-.393-.5-.5-.536c-.107-.036-.107-.108-.07-.286.035-.18.105-.322.141-.429l.037-.107s.221-.56.403-1.226a20.593 20.593 0 0111.245 4.457c-.263.5-.555 1.03-.506 1.233.073.285.18.964.18.964s-.107.465-.643.322c-.536-.143-.893-.536-.928-.679-.036-.142-.18-.667-.357-.852-.18-.184-.429-.613-.537-.327-.106.286-.035.5 0 .893.036.394.358 1.18.465 1.18.107 0 .75.285.75.285v.465s-.072-.036-.32 0c-.252.035-.83.785-.951.536-.122-.251-.3-.323-.3-.108v.214s.715 1.071 0 .286c-.714-.786-.571-.607-.714-.786-.143-.179-.571-.036-1-.25-.428-.214-.786-.465-.786-.465s-1 .072-1.214.465c-.215.393-.75.714-.91.964-.161.25-.09.393-.555 1.269-.464.874-.749 1.017-.964 1.231-.214.215.322 1.357.322 1.357l.75-.321s.036-.143.18.07c.142.216.356.894.678.68.321-.214.5-1.608.5-1.608s-.215-.964 0-1.213c.214-.25.607-.643.642-.43.036.215-.035 1.68.251 1.68.287 0 1.107.143 1.107.143l-.928.607s-.215.618-.358.862c-.143.245-.82.494-.964.53-.143.037-.607 0-.607 0s-.286.247-.357.016a5.133 5.133 0 00-.251-.587s-.142.285-.213.392c-.072.108-.536.857-.644 1-.107.143-.321.5-.321.5l-.428.68s-.537.07-.572.178c-.036.107-.25.5-.25.5s.572-.25.572 0-.251.678-.394.75c-.142.07-.357-.394-.75 0-.394.393-.857 1.107-.965 1.214-.107.107.571.785.715.893l.142.107s.25-.107-.035.465c-.286.571-.18.357-.286.571-.107.215-.429.428-.536.822-.107.392.214.18-.178.536-.393.356-.466.82-.661 1.035-.197.214-.125.715-.232.964l-.108.251s-.035.57 0 .714c.036.143.428.928.537 1.107.106.18.642.964.642.964l1.143.393h.856l.715-.214s-.322-.108.143-.179c.463-.071-.108-.214.463-.071a5.34 5.34 0 011.143.464s.143.072 0 .322c-.142.25-.428.071-.07.536.356.465.535.679.571 1.107.035.429.321 1.179.321 1.179l-.072 1.285s-.142.143-.142.464c0 .322.071.572.071.572s.628.214.546.75c-.081.536.082 1.429 0 1.572-.081.143.74 1.178.74 1.178s0-.071.285 0c.287.071.965-.536 1.322-.678.357-.143.965-.822 1.286-1.286.32-.464.57-1.107.57-1.214 0-.107-.178.286 0-.107.18-.393 0-.25.18-.393.18-.143.57-.643.714-.894.143-.25.25-.356.25-.856s-.107-1.25-.107-1.25-.25.178.036-.25c.287-.43.25-.465.393-.643.143-.179.214-.25.714-.929.5-.678.715-.893 1-1.321.286-.428.428-.714.428-.714s-.036-.286-.142-.286h-.43c-.106 0-.07-.071-.284-.071-.215 0-.858-.18-.607-.358.249-.179.285-.214.5-.285.214-.072 1.285-.679 1.499-.893.215-.214.287-.214.644-.5.355-.286.428-.5.428-.643 0-.142-.214-.25-.322-.428-.107-.179-.536-.463-.642-.392-.109.07-.109.25-.43 0-.322-.252-1.106-.93-1.142-1.037-.035-.107.75.214.857.214.106 0 1.179.25 1.679.322.5.071 1.285.287 1.536.5.25.214.75.857 1.285 1.321.536.465.822 1.179.858 1.393.035.214-.108.357.357 1.393.068.153.119.283.166.41-2.444 8.7-10.444 15.1-19.917 15.1zm7-21.261l-.428.428s-.786-.607-.893-.607c-.107 0-.393-.229-.393-.229l-.5-.77s-.607-.037-.822 0c-.214.035-1 .106-1.321.25v-.394s.322-.321.5-.535c.179-.214.356-.643.356-.643s.607-.072.68.035c.07.108.357.358.464.537.107.178.215-.786.215-.786s.607.357.749.571c.143.215-.106.607.072.75.178.143.5 0 .607-.035.107-.036.07-.18.22-.5.148-.322.244.107.46.32.213.216.463.287.678.108.214-.178 0-.642.356-.642.357 0 .215.179.215.286 0 .106 1.892.662 1.892.662s.322.409.251.588c-.072.178-.965.678-1.072.714-.107.036-1.57-.322-2.036-.49-.464-.17-.25.382-.25.382zm2.071-3.429l.143-.071c.143-.071.571-.428.571-.5 0-.072.433 0 .433 0s.353.429.639.607c.286.179.214.484.214.484l-.357.373s-.786-.321-.893-.357c-.107-.036-.214 0-.214 0l-.25.18s-.43-.037-.537 0c-.106.034.251-.716.251-.716zm1.607 4.428c.04 0 .071.067.108.169.06.164.133.418.293.617.258.322.636 1.071.85 1.393.215.321.322.893.322.964 0 .072-.536 0-.536 0s-.429-.82-.636-.928c-.205-.107-.185-.464-.33-.75-.141-.286-.534-.893-.57-1.465h.5z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M25.318 38.363c.204-.034.373-.484.373-.484v-.33l-.796-.17s.05.035-.22 0c-.27-.034-.575 0-.575 0 0 .542.304.983.304.983s.711.034.914 0zM29.693 32.841c.101.102.44-.03.507-.218.069-.188.17-.493.204-.594.034-.103.44-.678.44-.678l-.304-.203s-.543.372-.678.406c-.135.034-.61.136-.61.136l-.136.17.137.545c.1.165.337.335.44.436zM36.398 59.266v.864c.356.102.558.406.712 0 .152-.407.406-1.17.456-1.372.052-.204.45-1.27.45-1.27l-.808.864-.81.914zM27.25 41.658c-.077.103-.35.61-.35.61s-.194.407-.062.636c.132.228.31 0 .31 0 .178-.204.474-.33.474-.33s.49-.357.49-.432c0-.077-.534-.738-.482-.89.05-.152-.127-.686-.178-.839-.05-.152-.025-.279-.305-.228-.28.05-.392 1.042-.247 1.042.145 0 .426.33.35.431z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.588 42.192c.05-.076.278-.57.201-.603-.074-.032-.329-.286-.329-.286l-.458.127v.762l.229.305.357-.305zM13.41 48.9c-.1-.051-1.202-.695-1.287-.728-.084-.035-.542 0-.542 0s-.372.203-.338.253c.034.052.185.257.237.196.051-.06.187-.145.187-.145s.237.034.423.17c.187.135.745.44.812.44.069 0 .61-.136.509-.186zM13.998 49.019c-.216 0-.479.101-.576.135-.097.034-.284.136-.183.254.103.12.357.136.357.136.05 0 .609.068.745 0 .135-.068 0-.306 0-.306s-.125-.22-.343-.22z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.201 17.168l-5.489 2.88c-.899.472-1.489.046-1.317-.955l1.049-6.102-4.44-4.32c-.728-.709-.504-1.4.502-1.547l6.137-.89L24.387.682c.45-.91 1.178-.91 1.628 0l2.745 5.552 6.136.89c1.005.146 1.231.838.503 1.546l-4.44 4.321 1.048 6.102c.172 1-.417 1.428-1.317.955l-5.489-2.88z",
      fill: "#000"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M25.23 22.54C11.32 22.54 0 33.859 0 47.77c0 13.913 11.319 25.231 25.23 25.231 13.913 0 25.232-11.318 25.232-25.23S39.142 22.54 25.23 22.54zm0 47.658c-12.365 0-22.427-10.061-22.427-22.427s10.062-22.428 22.428-22.428c12.366 0 22.427 10.062 22.427 22.428 0 12.366-10.061 22.427-22.427 22.427z",
      fill: "#000"
    })]
  }));
};

var MemoWorldsBest = /*#__PURE__*/(0,react.memo)(WorldsBest);
/* harmony default export */ var icons_WorldsBest = (MemoWorldsBest);
// EXTERNAL MODULE: ./app/components/auth/auth.component.tsx + 7 modules
var auth_component = __webpack_require__(35052);
// EXTERNAL MODULE: ./app/components/auth/premium-auth-guard.module.scss
var premium_auth_guard_module = __webpack_require__(75641);
var premium_auth_guard_module_default = /*#__PURE__*/__webpack_require__.n(premium_auth_guard_module);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
;// CONCATENATED MODULE: ./app/components/auth/premium-auth-guard.component.tsx





























var PremiumAuthGuard = function PremiumAuthGuard(_ref) {
  var _session$user, _session$user3, _session$user6;

  var onClose = _ref.onClose,
      onAuth = _ref.onAuth,
      className = _ref.className;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      premiumVersion = _useFeaturesContext.premiumVersion;

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var _useFeaturesContext2 = (0,features_context/* useFeaturesContext */.Pp)(),
      showQRCode = _useFeaturesContext2.showQRCode;

  var isLoggedAndShowQR = showQRCode && (session === null || session === void 0 ? void 0 : session.user);
  var t = (0,lang/* useTranslate */.q)();
  var goBackCallback = (0,react.useCallback)(function () {
    if (onClose) {
      onClose();
    }
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("PremiumAuthGuard", goBackCallback);

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      priceData = _usePlayerContext.priceData;

  var _usePostPillowBilling = (0,hooks/* usePostPillowBillingStripeV2Payment_link */.re)(),
      stripeLinkData = _usePostPillowBilling.data,
      loadStripeLink = _usePostPillowBilling.mutate,
      isStripeLoading = _usePostPillowBilling.isLoading;

  var QRValue = (0,react.useMemo)(function () {
    return stripeLinkData === null || stripeLinkData === void 0 ? void 0 : stripeLinkData.data.data.url;
  }, [stripeLinkData === null || stripeLinkData === void 0 ? void 0 : stripeLinkData.data.data.url]);
  var navigatePath = (0,navigation_hook/* useNavigatePath */.xQ)();
  (0,react.useEffect)(function () {
    if (session !== null && session !== void 0 && session.user) {
      if (showQRCode) {
        loadStripeLink({
          requestBody: {}
        });
      } else {
        loadStripeLink({
          requestBody: {
            redirect_url: "".concat(window.location.origin, "/get-premium")
          }
        });
      }
    }
  }, [session === null || session === void 0 ? void 0 : (_session$user = session.user) === null || _session$user === void 0 ? void 0 : _session$user.id]);
  (0,react.useEffect)(function () {
    var _session$user2;

    if (premiumVersion || session !== null && session !== void 0 && (_session$user2 = session.user) !== null && _session$user2 !== void 0 && _session$user2.premium) {
      navigatePath("/");
    }
  }, [premiumVersion, session === null || session === void 0 ? void 0 : (_session$user3 = session.user) === null || _session$user3 === void 0 ? void 0 : _session$user3.premium]);

  var _useAuth = (0,auth_context/* useAuth */.a)(),
      fetchUserData = _useAuth.fetchUserData,
      updateUserData = _useAuth.updateUserData;

  (0,useInterval/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _session$user4;

    var resp;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(session !== null && session !== void 0 && session.user && !(session !== null && session !== void 0 && (_session$user4 = session.user) !== null && _session$user4 !== void 0 && _session$user4.premium))) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return fetchUserData();

          case 3:
            resp = _context.sent;

            if (resp.data.data.premium) {
              updateUserData(resp);
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 1000);
  (0,react.useEffect)(function () {
    var _session$user5;

    if (session !== null && session !== void 0 && (_session$user5 = session.user) !== null && _session$user5 !== void 0 && _session$user5.premium) {
      navigatePath("/settings");
    }
  }, [session === null || session === void 0 ? void 0 : (_session$user6 = session.user) === null || _session$user6 === void 0 ? void 0 : _session$user6.premium]);

  var goToBuyPremium = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (session !== null && session !== void 0 && session.user && stripeLinkData !== null && stripeLinkData !== void 0 && stripeLinkData.data.data.url) {
                try {
                  window.location.href = stripeLinkData.data.data.url;
                } catch (e) {
                  console.error(e);
                }
              } else if (!(session !== null && session !== void 0 && session.user)) {
                setShowAuth(true);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function goToBuyPremium() {
      return _ref3.apply(this, arguments);
    };
  }();

  var _useState = (0,react.useState)(false),
      showAuth = _useState[0],
      setShowAuth = _useState[1];

  var onAuthSuccess = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(session) {
      var _session$user7;

      var stripeUrl;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setShowAuth(false);

              if (!(!((_session$user7 = session.user) !== null && _session$user7 !== void 0 && _session$user7.premium) && !showQRCode)) {
                _context3.next = 13;
                break;
              }

              _context3.prev = 2;
              _context3.next = 5;
              return (0,services/* postPillowBillingStripeV2Payment_link */.Z_)({
                redirect_url: "".concat(window.location.origin, "/get-premium")
              });

            case 5:
              stripeUrl = _context3.sent;
              window.location.href = stripeUrl.data.data.url;
              _context3.next = 11;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](2);

            case 11:
              _context3.next = 14;
              break;

            case 13:
              onAuth();

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 9]]);
    }));

    return function onAuthSuccess(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var authCloseCallback = (0,react.useCallback)(function () {
    setShowAuth(false);
  }, [setShowAuth]);
  var authSuccessCallback = (0,react.useCallback)(function (session) {
    return onAuthSuccess(session);
  }, [onAuthSuccess]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).wrapper, className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (premium_auth_guard_module_default()).back_wrapper,
      "data-navigate-row": true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButton */.x, {
        onClick: onClose
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).inner_wrapper, (0,defineProperty/* default */.Z)({}, (premium_auth_guard_module_default()).show_qr, isLoggedAndShowQR)),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).go_premium, (0,defineProperty/* default */.Z)({}, (premium_auth_guard_module_default()).show_qr, isLoggedAndShowQR)),
        "data-navigate-row": true,
        children: [isLoggedAndShowQR && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (premium_auth_guard_module_default()).go_premium_text,
          children: isStripeLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: t("premium.go-premium-for", {
                  var1: "".concat(priceData.amount).concat(priceData.currency_symbol)
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: t("premium.scan-qr-code")
            })]
          })
        }), !isLoggedAndShowQR && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: goToBuyPremium,
          "data-navigate-item": true,
          className: (premium_auth_guard_module_default()).go_premium_button,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: isStripeLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
              dark: true
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: t("premium.go-premium-for", {
                var1: "".concat(priceData.amount).concat(priceData.currency_symbol)
              })
            })
          })
        }), isLoggedAndShowQR && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (premium_auth_guard_module_default()).qr_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
            value: QRValue || "",
            size: 231
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (premium_auth_guard_module_default()).benefits_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (premium_auth_guard_module_default()).benefits1,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).box, (premium_auth_guard_module_default()).box_noads),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (premium_auth_guard_module_default()).icon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_NoAds, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (premium_auth_guard_module_default()).text,
              children: [t("premium.no-ads"), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: t("premium.no-ads-desc")
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).box, (premium_auth_guard_module_default()).box_playlist),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (premium_auth_guard_module_default()).icon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AddToPlaylist/* default */.Z, {
                color: "#000"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (premium_auth_guard_module_default()).text,
              children: [t("export-to-playlist"), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: t("premium.export-to-playlist-desc")
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).box, (premium_auth_guard_module_default()).box_autoplay),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (premium_auth_guard_module_default()).icon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_WindbackBig, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (premium_auth_guard_module_default()).text,
              children: [t("autoplay"), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: t("premium.automatically-play-last-radio")
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (premium_auth_guard_module_default()).benefits2,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).box, (premium_auth_guard_module_default()).box_worlds_best),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (premium_auth_guard_module_default()).icon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_WorldsBest, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (premium_auth_guard_module_default()).text,
              children: [t("premium.worlds-best"), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: t("premium.worlds-best-desc")
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((premium_auth_guard_module_default()).box, (premium_auth_guard_module_default()).box_hq),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (premium_auth_guard_module_default()).icon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons_HighQualityOutlined, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (premium_auth_guard_module_default()).text,
              children: [t("hq-stations"), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: t("premium.hq-stations-desc")
              })]
            })]
          })]
        })]
      })]
    }), showAuth && /*#__PURE__*/(0,jsx_runtime.jsx)(auth_component/* AuthGuardPopup */.J, {
      onSuccess: authSuccessCallback,
      onClose: authCloseCallback
    })]
  });
};

/***/ }),

/***/ 2035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var AddToPlaylist = function AddToPlaylist(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#fff" : _ref$color;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 43",
    fill: "none",
    className: className,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
      filter: "url(#prefix__filter0_d_4411_9871)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M30.006 32.805c2.46 0 4.453-1.709 4.453-3.817 0-2.107-1.994-3.816-4.453-3.816-2.459 0-4.452 1.709-4.452 3.816 0 2.108 1.993 3.817 4.452 3.817zM9.652 37.893c2.459 0 4.452-1.709 4.452-3.817s-1.993-3.816-4.452-3.816c-2.46 0-4.453 1.708-4.453 3.816 0 2.108 1.994 3.817 4.453 3.817z",
        stroke: color,
        strokeWidth: 2.806,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.508 22.517a8.972 8.972 0 01-2.806 0v12.196a1.403 1.403 0 002.806 0V22.517zm7.278-10.79l10.27-2.568v20.465a1.403 1.403 0 002.806 0V7.363A1.403 1.403 0 0034.12 6l-12.4 3.1a8.85 8.85 0 011.067 2.625z",
        fill: color
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
        cx: 13.647,
        cy: 12.469,
        r: 9.423,
        stroke: color,
        strokeWidth: 2.525
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
        filter: "url(#prefix__filter1_d_4411_9871)",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.699 7.89V6.838h-2.105v4.58H8.015v2.104H12.594v4.58H14.7v-4.58H19.278v-2.104H14.7V7.89z",
          fill: color
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("filter", {
        id: "prefix__filter0_d_4411_9871",
        x: 0.722,
        y: 0.672,
        width: 37.379,
        height: 41.99,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feOffset", {
          dy: 1.128
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feGaussianBlur", {
          stdDeviation: 1.119
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4411_9871"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4411_9871",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("filter", {
        id: "prefix__filter1_d_4411_9871",
        x: 5.776,
        y: 5.727,
        width: 15.742,
        height: 15.742,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feOffset", {
          dy: 1.128
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feGaussianBlur", {
          stdDeviation: 1.119
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4411_9871"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4411_9871",
          result: "shape"
        })]
      })]
    })]
  });
};

var MemoAddToPlaylist = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(AddToPlaylist);
/* harmony default export */ __webpack_exports__["Z"] = (MemoAddToPlaylist);

/***/ }),

/***/ 75641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","go_premium":"premium-auth-guard_go_premium__zoGfR","wrapper":"premium-auth-guard_wrapper__iXW_2","back_wrapper":"premium-auth-guard_back_wrapper__iE1G1","inner_wrapper":"premium-auth-guard_inner_wrapper__u358m","benefits1":"premium-auth-guard_benefits1__JTLtu","benefits2":"premium-auth-guard_benefits2__UV4fO","show_qr":"premium-auth-guard_show_qr__HdWyB","benefits_wrapper":"premium-auth-guard_benefits_wrapper__tUjTG","loader_wrapper":"premium-auth-guard_loader_wrapper__cXXRb","loader":"premium-auth-guard_loader___Bt78","go_premium_button":"premium-auth-guard_go_premium_button__RlgDI","qr_wrapper":"premium-auth-guard_qr_wrapper__bRda6","go_premium_text":"premium-auth-guard_go_premium_text__nCqKp","box":"premium-auth-guard_box__YTc9i","icon":"premium-auth-guard_icon__ZPOZl","text":"premium-auth-guard_text__Xn7zu","box_search":"premium-auth-guard_box_search__77vv0","box_discover":"premium-auth-guard_box_discover__Q5nhx","box_offline":"premium-auth-guard_box_offline__141Mr","box_noads":"premium-auth-guard_box_noads__VG7Bq","box_playlist":"premium-auth-guard_box_playlist__KZAKa","box_autoplay":"premium-auth-guard_box_autoplay__qO6Yd","box_cross_device":"premium-auth-guard_box_cross_device___gnNn","box_resume":"premium-auth-guard_box_resume__YzJEL","box_worlds_best":"premium-auth-guard_box_worlds_best__5bsgv","box_hq":"premium-auth-guard_box_hq__1aDYe","mini_box":"premium-auth-guard_mini_box__7IKEe"};

/***/ })

}]);